export default "__VITE_ASSET__CtB2wXNu__"